(() => {
  function enhanceBundles(root = document) {
    root.querySelectorAll('#block-bundles .variant-product-card').forEach(card => {
      if (card.dataset.ehAccessible) return;
      card.dataset.ehAccessible = 'true';
      card.tabIndex = 0;
      card.setAttribute('role', 'button');
      card.setAttribute('aria-label', card.dataset.variantTitle);
      const sync = () => card.setAttribute('aria-pressed', String(card.classList.contains('selected')));
      sync();
      new MutationObserver(sync).observe(card, { attributes: true, attributeFilter: ['class'] });
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          card.click();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceBundles());
  else enhanceBundles();
  document.addEventListener('shopify:section:load', event => enhanceBundles(event.target));
})();

(() => {
  function enhanceFAQs(root = document) {
    root.querySelectorAll('.store-faq').forEach(faq => {
      faq.querySelectorAll('.store-faq-item').forEach((item, index) => {
        const question = item.querySelector('.store-faq-question');
        const answer = item.querySelector('.store-faq-answer');
        if (!question || !answer || question.dataset.ehAccessible) return;
        question.dataset.ehAccessible = 'true';
        question.setAttribute('role', 'button');
        question.tabIndex = 0;
        question.id = question.id || `${faq.id}-question-${index}`;
        answer.id = answer.id || `${faq.id}-answer-${index}`;
        question.setAttribute('aria-controls', answer.id);
        question.setAttribute('aria-label', question.querySelector('span')?.textContent.trim() || 'Show answer');
        answer.setAttribute('aria-labelledby', question.id);
        const sync = () => {
          const open = item.classList.contains('active');
          question.setAttribute('aria-expanded', String(open));
          answer.setAttribute('aria-hidden', String(!open));
          answer.toggleAttribute('inert', !open);
        };
        sync();
        new MutationObserver(sync).observe(item, { attributes: true, attributeFilter: ['class'] });
        question.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            question.click();
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceFAQs());
  else enhanceFAQs();
  document.addEventListener('shopify:section:load', event => enhanceFAQs(event.target));
})();

